import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "jwStudentRoll/";

// 学籍卡 - 详情
export const rollCardView = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "jwRollId", {
           data: _params,
           method: "GET",
         });
       };

// 学籍卡 - 提交
export const rollCardSubmit = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "submitRollCards", {
    data: _params,
    method: "POST",
  });
};
// 学籍卡 - 保存
export const rollCardSave = (params) => {
  // let _params = cleanParams(params);
  return sendRequest(api.url + _base + "saveRollCards", {
    data: params,
    method: "POST",
  });
};
// 学籍卡 - 获取状态
export const rollCardStatus = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "getRollCardStatus", {
    data: _params,
    method: "GET",
  });
};
// 学籍信息 - 下载学籍卡
export const exportRollPDF = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "exportRollPDF", {
           data: _params,
           method: "GET",
         });
       };

// 毕业档案 - 获取毕业档案相关信息
export const getGraduateRecordInfo = () => {
  return sendRequest(api.url + _base + "getGraduateRecordInfo", {
    method: "GET",
  });
};

// 毕业档案 - 获取学位申请详细信息
export const getDegreeApplyDetail = () => {
  return sendRequest(api.url + _base + "getDegreeApplyDetail", {
    method: "GET",
  });
};

// 毕业档案 - 学士学位申请
export const applyDegree = (params) => {
  return sendRequest(api.url + _base + "applyDegree", {
    method: "POST",
    data: params || {},
  });
};

// 毕业档案 - 获取毕业实习鉴定详情
export const getInternshipEvaluateDetail = () => {
  return sendRequest(api.url + _base + "getInternshipEvaluateDetail", {
    method: "GET",
  });
};

// 毕业档案 - 申请毕业实习鉴定
export const applyInternshipEvaluate = (params) => {
  return sendRequest(api.url + _base + "applyInternshipEvaluate", {
    data: params,
    method: "POST",
  });
};

// 毕业档案 - 下载毕业实习鉴定表
export const downloadInternshipEvaluate = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "downloadInternshipEvaluate", {
    data: _params,
    method: "GET",
  });
};

// 毕业档案 - 上传毕业实习鉴定表
export const uploadInternshipEvaluate = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "uploadInternshipEvaluate", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};

// 毕业档案 - 毕业信息核对
export const verifyGraduateInfo = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "verifyGraduateInfo", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/rollCard.js